import { crv, cva } from '@/styled-system/css';

export const toggleButtonRecipe = cva({
  base: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow, background-color',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    transitionTimingFunction: '{easings.ease}',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {
        cursor: 'pointer',
      },
    },
    loading: {
      true: {},
      false: {},
    },

    ...crv('fluid', {
      true: {
        width: '100%',
      },
      false: {
        width: 'auto',
      },
    }),

    selected: {
      true: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color)',
          _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
        backgroundColor: {
          base: 'bg.action.soft.selected.default',
          _notDisabled: {
            _hover: 'bg.action.soft.selected.hover',
            _active: 'bg.action.soft.selected.pressed',
          },
        },
        boxShadowColor: {
          base: 'border.action.hero.selected.default',
          _notDisabled: {
            _hover: 'ToggleButton.border.selectedHover',
            _active: 'ToggleButton.border.selectedPressed',
          },
        },
      },
      false: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
          _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
        backgroundColor: {
          base: 'bg.action.neutral.default',
          _notDisabled: {
            _hover: 'bg.action.neutral.hover',
            _active: 'bg.action.neutral.pressed',
          },
        },
        boxShadowColor: {
          base: 'border.action.neutral.default',
          _notDisabled: {
            _hover: 'border.action.neutral.hover',
            _active: 'border.action.neutral.pressed',
          },
        },
      },
    },

    size: {
      sm: {
        borderRadius: 'obj.default',
        gap: 'tighter',
        paddingBlock: 'ToggleButton.sm.padding.vert',
        paddingInline: 'default',
      },
      md: {
        borderRadius: 'obj.default',
        gap: 'tighter',
        paddingBlock: 'ToggleButton.md.padding.vert',
        paddingInline: 'default',
      },
      lg: {
        borderRadius: 'obj.default',
        gap: 'tighter',
        paddingBlock: 'default',
        paddingInline: 'default',
      },
    },
  },
});
